module.exports = __webpack_public_path__ + "static/media/stake.8c67fd8c.png";